// extracted by mini-css-extract-plugin
export default {"menu":"style_menu__nw69Y","content":"style_content__Kokv3","menus":"style_menus__b+klx","item":"style_item__Gara-"};